import React from 'react';
import Chart from "chart.js";

class Heart extends React.Component {
  constructor(props) {
    super(props)
    this.chartRef = React.createRef();
  }
  componentDidMount() {
    const myChartRef = this.chartRef.current.getContext("2d");
    new Chart(myChartRef, {
      type: 'line',
      data: {
          datasets: [{
              label: 'Heart Rate',
              backgroundColor: 'rgba(255, 99, 132, 0.2)',
              borderColor: 'rgba(255, 99, 132, 1)',
              data: [
                {x:new Date("2020-12-9 07:03:53"), y:63},
                {x:new Date("2020-12-9 07:05:28"), y:60},
                {x:new Date("2020-12-9 07:07:01"), y:63},
                {x:new Date("2020-12-9 07:08:35"), y:67},
                {x:new Date("2020-12-9 07:10:08"), y:60},
                {x:new Date("2020-12-9 07:11:45"), y:58},
                {x:new Date("2020-12-9 07:13:19"), y:53},
                {x:new Date("2020-12-9 07:14:53"), y:62},
                {x:new Date("2020-12-9 07:16:26"), y:64},
                {x:new Date("2020-12-9 07:18:00"), y:63},
                {x:new Date("2020-12-9 07:19:33"), y:53},
                {x:new Date("2020-12-9 07:21:05"), y:39},
                {x:new Date("2020-12-9 07:22:37"), y:46},
                {x:new Date("2020-12-9 07:24:11"), y:59},
                {x:new Date("2020-12-9 07:25:41"), y:63},
                {x:new Date("2020-12-9 07:27:17"), y:58},
                {x:new Date("2020-12-9 07:28:48"), y:61},
                {x:new Date("2020-12-9 07:30:21"), y:69},
                {x:new Date("2020-12-9 07:31:53"), y:54},
                {x:new Date("2020-12-9 07:33:26"), y:59},
                {x:new Date("2020-12-9 07:34:58"), y:56},
              ],
              fill: false
          }]
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        title: {
          display: true,
          text: 'Heart Rate over Time'
        },
        hover: {
          mode: 'nearest',
          intersect: true
        },
        scales: {
          xAxes: [{
            display: true,
            type: 'time',
            time: {
              unit: 'minute'
            },
            scaleLabel: {
              display: true,
              labelString: 'Time'
            }
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: 'Heart Rate (BPM)'
            }
          }]
        }
      }
    });
  }
  render() {
        return (
          <div className="chart-container">
            <canvas id="type" ref={this.chartRef} aria-label="Pie chart that displays the data described in the above paragraph." role="img">
              <p>
                Line chart that displays a section of heart rate collected by Parker Ruth during testing.
              </p>
            </canvas>
          </div>
        )
    }
}

export default Heart;
